import CircularProgress from '@mui/material/CircularProgress';

const Exploit = () => {

    return <div className="w-full text-center pt-100">
        <CircularProgress color="primary" size="10rem" />
    </div>
}

export default Exploit